function cov_isqu8env5() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/List.tsx";
  var hash = "895c3371ca9d4cfe8c2b3e29dc435818f97ca04c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 9,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "895c3371ca9d4cfe8c2b3e29dc435818f97ca04c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_isqu8env5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_isqu8env5();
var Icon = (cov_isqu8env5().s[0]++, {
  name: 'list',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.25 4C22.25 4.69036 21.6904 5.25 21 5.25H11C10.3096 5.25 9.75 4.69036 9.75 4C9.75 3.30964 10.3096 2.75 11 2.75H21C21.6904 2.75 22.25 3.30964 22.25 4Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.25 12C20.25 12.6904 19.6904 13.25 19 13.25L11 13.25C10.3096 13.25 9.75 12.6904 9.75 12C9.75 11.3096 10.3096 10.75 11 10.75H19C19.6904 10.75 20.25 11.3096 20.25 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.25 20C22.25 20.6904 21.6904 21.25 21 21.25H11C10.3096 21.25 9.75 20.6904 9.75 20C9.75 19.3096 10.3096 18.75 11 18.75H21C21.6904 18.75 22.25 19.3096 22.25 20Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 3.25C4.58579 3.25 4.25 3.58579 4.25 4C4.25 4.41421 4.58579 4.75 5 4.75C5.41421 4.75 5.75 4.41421 5.75 4C5.75 3.58579 5.41421 3.25 5 3.25ZM1.75 4C1.75 2.20507 3.20507 0.75 5 0.75C6.79493 0.75 8.25 2.20507 8.25 4C8.25 5.79493 6.79493 7.25 5 7.25C3.20507 7.25 1.75 5.79493 1.75 4Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75C5.41421 12.75 5.75 12.4142 5.75 12C5.75 11.5858 5.41421 11.25 5 11.25ZM1.75 12C1.75 10.2051 3.20507 8.75 5 8.75C6.79493 8.75 8.25 10.2051 8.25 12C8.25 13.7949 6.79493 15.25 5 15.25C3.20507 15.25 1.75 13.7949 1.75 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 19.25C4.58579 19.25 4.25 19.5858 4.25 20C4.25 20.4142 4.58579 20.75 5 20.75C5.41421 20.75 5.75 20.4142 5.75 20C5.75 19.5858 5.41421 19.25 5 19.25ZM1.75 20C1.75 18.2051 3.20507 16.75 5 16.75C6.79493 16.75 8.25 18.2051 8.25 20C8.25 21.7949 6.79493 23.25 5 23.25C3.20507 23.25 1.75 21.7949 1.75 20Z\" fill=\"currentColor\"/>"
});
export default Icon;